import './Footer.css';
import logoImage from '../../assets/logo.png';

export default function Footer(){
    return (
        <footer className='footer'>
            <div className='footer__content'>
                <div className='footer__image-block'>
                    <img className='footer__image' alt='logo' title='Человек в поисках смысла' src={logoImage} />
                </div>
                <div className='footer__text-block'>
                    <a className='footer__link' href='https://t.me/frankl_logotherapy'>
                        Телеграм-канал <br /> 
                        <strong>Человек в поисках смысла</strong> <br />
                        t.me/frankl_logotherapy
                    </a>
                </div>
            </div>
        </footer>
    );
}